import { useQuery } from '@tanstack/react-query';

import config from 'configs/app';
import useFetch from 'lib/hooks/useFetch';

const feature = config.features.safe;

export default function useIsSafeAddress(hash: string | undefined): boolean {
  const fetch = useFetch();

  const { data } = useQuery({
    queryKey: [ 'safe_transaction_api', hash ],
    queryFn: async() => {
      if (!feature.isEnabled || !hash) {
        return Promise.reject();
      }

      return fetch(`${ feature.apiUrl }/${ hash }`);
    },
    enabled: feature.isEnabled && Boolean(hash),
    refetchOnMount: false,
  });

  return Boolean(data);
}

export function useIconUrl(hash: string | undefined): { readonly thumb: string } {
  const fetch = useFetch();

  const { data } = useQuery({
    queryKey: [ 'token_icons', hash ],
    queryFn: async() => {
      if (!hash) {
        return Promise.reject();
      }

      return fetch(` https://price.zeniq.services/v2/info/image/${ hash }/zeniq-smart-chain`);
    },
    enabled: Boolean(hash),
    refetchOnMount: false,
    placeholderData: { thumb: undefined },
  });

  return data as { readonly thumb: string };
}
